import store from '@/store'
import { useToast } from 'vue-toastification'
import router from '@/router'
import { isProductionEnvironment } from '@/plugins/helper.js'

const toast = useToast()

export default (to, from, next) => {
  if (store.state.auth.jwtPayload == null){
    const targetPath = to.fullPath || to.path;
    if (targetPath && targetPath !== "/" && targetPath !== "/validation") {
      store.commit("auth/setRedirectLink", targetPath);
      sessionStorage.setItem("redirectLink", targetPath);
    }
    if (store.state.auth.currentOrganisation && store.state.auth.currentOrganisation.id && typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem("selectedOrgId", store.state.auth.currentOrganisation.id);
    }
    store.dispatch('auth/logout');
    return;
  }

  const isProd = isProductionEnvironment();
  const isSuperAdmin = store.state.auth.isSuperAdmin;

  if (isProd && !isSuperAdmin) {
    toast.error("You are not authorized to view this page.");
    router.push('/dashboard');
    return next();
  }

  const isAuthorized = isSuperAdmin || 
                       store.state.auth.accessType === 'consultant_admin' || 
                       store.state.auth.accessType != null ||
                       store.state.auth.isAuditAdmin || 
                       store.state.auth.isOrganisationAdmin;

  if (!isAuthorized) {
    toast.error("You are not authorized to view this page.");
    router.push('/dashboard');
    return next();
  }
}
